module.exports = __webpack_public_path__ + "img/D7DFDB_AAB5AF_F5FAF7_BCC4C4-256px.9a8e9bbb.png";